export enum ProcessingStatusEnum {
    NotStarted = 0,
    InProgress = 1,
    Processed = 2,
    Completed = 3,
    Failed = 4,
    Cancelled = 5,
    ChunksCreated = 6,
    FailedToConvert = 7,
    FailedToCreateChunks = 8,
    FailedToIngest = 9,
}
